const AudiophileTheme = {
  colors: {
    brand: {
      peru: "#D87D4A",
      black: "#101010",
      white: "#F1F1F1",
      lotion: "#FAFAFA",
    },
    neutral: {
      tangelo: "#FBAF85",
      white: "#FFFFFF",
      black: "#000000",
    },
  },
  typography: {
    h1: "56px/58px 'Manrope', sans-serif",
    h2: "40px/44px 'Manrope', sans-serif",
    h3: "32px/36px 'Manrope', sans-serif",
    h4: "28px/38px 'Manrope', sans-serif",
    h5: "24px/33px 'Manrope', sans-serif",
    h6: "18px/24px 'Manrope', sans-serif",
    overline: "14px/19px 'Manrope', sans-serif",
    subTitle: "13px/25px 'Manrope', sans-serif",
    body: "15px/25px 'Manrope', sans-serif",
  },
  screens: {
    tablet: "@media (min-width: 640px)",
    laptop: "@media (min-width: 1024px)",
  },
};

export default AudiophileTheme;
